__turbopack_context__.v({
  "container": "_3djM2W_container",
  "highlight": "_3djM2W_highlight",
  "media": "_3djM2W_media",
});
